<template>
  <!-- 店铺详情 -->
  <div class="shop-detail">
    <!-- <Navbar :title="info.name"></Navbar> -->

    <van-nav-bar class="navber" fixed placeholder>
      <template #left>
        <van-icon @click="goBack" name="arrow-left" color="#fff" size="15px" />
      </template>
      <template #title>
        <span class="title">{{ info.name }}</span>
      </template>
      <template #right>
        <div class="right" @click="toEditShop">
          <span style="font-size: 12px; color: #fff; margin-left: 5px"
            >修改信息</span
          >
        </div>
      </template>
    </van-nav-bar>
    <div class="swiper-box">
      <van-swipe class="my-swipe" :autoplay="3000" :show-indicators="true">
        <van-swipe-item v-for="(item, index) in slideList" :key="index">
          <a :href="item.link">
            <img class="banner-img" :src="url + item.cover" alt="" />
          </a>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="shop-info">
      <div class="left">
        <div
          class="vip-box"
          v-if="info.service_info && info.service_info.vip_level"
        >
          <template v-if="info.service_info.vip_level.vip_level == 1">
            <i class="iconfont iconhuiyuandengji" style="color: #5f3e3e"></i>
            <span>普通会员</span>
          </template>
          <template v-else-if="info.service_info.vip_level.vip_level == 2">
            <i class="iconfont iconhuiyuandengji"></i>
            <span>黄金会员</span>
          </template>
          <template v-else-if="info.service_info.vip_level.vip_level == 3">
            <i class="iconfont iconhuiyuandengji" style="color: #bd419d"></i>
            <span>钻石会员</span>
          </template>
        </div>
        <div class="vip-box" v-else>
          <template>
            <i class="iconfont iconhuiyuandengji" style="color: #d8d8d8"></i>
            <span>体验会员</span>
          </template>
        </div>
        <!-- <img class="avatar" v-if="info.thumb" :src="url + info.thumb" alt="" /> -->
        <img class="avatar" v-if="info.thumb" :src="url + info.thumb" alt="" />
        <img
          v-else
          class="avatar"
          src="http://api.zglxgw.com/static/asset/index/images/lunbo.jpg"
          alt=""
        />
        <van-tag
          v-if="info.believe > 90"
          class="tag"
          color="#ff5722"
          text-color="#fff"
          >金牌师傅</van-tag
        >
        <van-tag
          v-else-if="info.believe > 80 && info.believe < 90"
          class="tag"
          color="#a7a7a7"
          text-color="#fff"
          >银牌师傅</van-tag
        >
        <van-tag
          v-else-if="info.believe < 80"
          class="tag"
          color="#7A443A"
          text-color="#fff"
          >铜牌师傅</van-tag
        >
        <van-rate
          v-if="info.service_info"
          :value="info.service_info.comment_star"
          :size="12"
          color="#ffd21e"
          void-icon="star"
          void-color="#eee"
        />
      </div>
      <div class="right">
        <div class="title">{{ info.name }}</div>
        <div class="subtit">简介：{{ info.desc }}</div>
        <a
          :href="`https://apis.map.qq.com/uri/v1/search?keyword=${info.address}&region=${info.city}&referer=U5LBZ-JMZC6-UWSSL-EI7JM-5UYL5-PXBWX`"
          class="subtit"
        >
          <i class="iconfont iconweizhi"></i> {{ info.address }}
        </a>
        <div class="btns">
          <!-- <a
            v-if="userInfo && userInfo.user_vip_info"
            :href="`tel:${info.phone}`"
            class="btn"
          >
            <i class="iconfont icondianhua"></i>
            <span>电话联系</span>
          </a>
          <a v-else :href="`tel:4006912808`" class="btn">
            <i class="iconfont icondianhua"></i>
            <span>电话联系</span>
          </a>
          <div class="btn" @click="toChat">
            <i class="iconfont iconxiaoxi"></i>
            <span>在线联系</span>
          </div> -->
        </div>
      </div>
    </div>
    <van-tabs
      v-model="active"
      color="#2F78DC"
      line-height="1px"
      line-width="64px"
      @change="onTabChange"
    >
      <van-tab title="店铺视频" name="1">
        <div class="tabs-box">
          <div class="card-box">
            <div class="title">
              <span>店铺视频</span>
              <span @click="toUploadVideo" class="btn"
                ><i class="iconfont iconchuanshu_shangchuan"></i> 发布视频</span
              >
            </div>
            <div class="list">
              <div
                class="video-item"
                v-for="(item, index) in videoList"
                :key="'video' + index"
              >
                <video
                  :src="url + item.video_url"
                  controls="controls"
                  poster="@/assets/image/banner1.jpg"
                ></video>
                <div class="text" style="font-size: 14px">
                  <span>{{ item.name }}</span>
                  <span class="delete-btn" @click="onVideoDelete(item.id)">删除</span>
                </div>
                <!-- <div class="cover-box">
                  <div class="icon"><i class="iconfont iconbofang"></i></div>
                  <img :src="item.cover" alt="" />
                </div>
                <div class="text" style="font-size: 14px">{{ item.name }}</div> -->
              </div>
              <div class="empty" v-if="videoList.length == 0">
                <van-empty image-size="100" description="暂无数据" />
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="行业资讯" name="2">
        <div class="tabs-box">
          <div class="card-box">
            <div class="title">
              <span>行业资讯</span>
              <span @click="toSendNews" class="btn"
                ><i class="iconfont iconchuanshu_shangchuan"></i> 发布资讯</span
              >
            </div>
            <div class="news-list">
              <div class="news-item" v-for="(item,index) in newsList" :key="index" @click="toNewsDetail(item.id)">
                <img :src="url + item.thumb" alt="">
                <div class="right">
                  <p class="name">{{item.name}}</p>
                  <p class="time">
                    点赞：{{item.zan_count}} 浏览量：{{item.hits}}
                  </p>
                  <p class="time">发布时间：{{item.created_at}}</p>
                </div>
              </div>
              <div class="empty-box" v-if="newsList.length == 0">暂无数据 ~</div>
              <div class="more-btn" v-if="newsList.length >= per_page" @click="onMore">加载更多</div> 
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="店铺详情" name="3">
        <div class="tabs-box">
          <div class="card-box" style="margin-bottom:20px;">
            <div class="title">服务信息</div>
            <div class="content">
              <div class="subtit">维修范围</div>
              <div class="text">{{ info.scope_desc }}</div>
              <div class="subtit">服务区域</div>
              <div class="text">{{ info.service_desc }}</div>
              <div class="subtit">执照证书</div>
              <div class="imgs">
                <template v-if="info.bus_img">
                  <img :src="info.bus_img" alt="" />
                </template>
                <template v-if="info.hor_img && info.hor_img.length > 0">
                  <img
                    v-for="(src, index) in info.hor_img"
                    :key="'hor' + index"
                    :src="src"
                    alt=""
                  />
                </template>
              </div>
            </div>
          </div>
          <div class="card-box">
            <div class="title">评价信息</div>
            <div class="list">
              <div
                class="item"
                v-for="(item, index) in pinglunList"
                :key="index"
              >
                <div class="top">
                  <img
                    v-if="item.get_user_info && item.get_user_info.avatar"
                    :src="item.get_user_info.avatar"
                    alt=""
                  />
                  <img v-else src="@/assets/image/user.png" alt="" />
                  <div class="right" v-if="item.get_user_info">
                    <p class="name" v-if="item.get_user_info.nickname">
                      {{ item.get_user_info.nickname }}
                    </p>
                    <p class="name" v-else-if="item.get_user_info.truename">
                      {{ item.get_user_info.truename }}
                    </p>
                    <p class="start">
                      <van-rate
                        :value="item.comment_stars"
                        :size="12"
                        color="#ffd21e"
                        void-icon="star"
                        void-color="#eee"
                      />
                      <span class="time">{{ item.created_at }}</span>
                    </p>
                  </div>
                </div>
                <div class="bottom">
                  {{ item.comment_desc }}
                </div>
              </div>
              <div class="empty" v-if="pinglunList.length == 0">
                <van-empty image-size="100" description="暂无评论数据" />
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="产品展示" name="4">
        <div class="tabs-box">
          <div class="card-box">
            <div class="title">
              <span>产品展示</span>
            </div>
            <div class="search-box">
              <div class="input-box">
                <van-icon class="icon" name="search" />
                <van-search left-icon="" v-model="productQuery.keyword" class="input" placeholder="产品搜索" @search="onSearch" @clear="onInputClear" />
              </div>
              <div class="type-btn" @click="treeSelectShow = true">
                <span>产品分类</span>
                <van-icon name="arrow-down" />
              </div>
            </div>
            <div class="type" @click="treeSelectShow = true" v-if="classValue" >
              <span>产品分类：{{classValue}}</span>
              <van-icon name="close" size="16px" @click.stop="onclear" />
            </div>
            <div class="product-list">
              <div class="item" v-for="(item,index) in goodsList" :key="index" @click="toProductDetail(item.id)">
                <img :src="url + item.image" alt="">
                <span>{{item.goods_name}}</span>
              </div>
              <div style="margin: 0 auto;" class="empty" v-if="goodsList.length == 0">
                <van-empty image-size="100" description="暂无产品数据" />
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div class="btns" v-if="active == 4">
      <router-link class="btn" :to="{ path: '/classList', query: { id: uid } }">
        <van-icon name="setting-o" />
        <span>分类管理</span>
      </router-link>
      <router-link
        class="btn"
        :to="{ path: '/productAdd', query: { id: uid } }"
      >
        <van-icon name="plus" />
        <span>添加产品</span>
      </router-link>
    </div>
    <van-popup v-model="treeSelectShow" round position="bottom">
      <van-picker
        ref="classPicker"
        show-toolbar
        :columns="columns"
        @cancel="treeSelectShow = false"
        @confirm="onConfirm"
        value-key="name"
      />
    </van-popup>
    <Tabber></Tabber>
  </div>
</template>

<script>
import Navbar from "../../components/Navbar";
import Tabber from "../../components/Tabber";
import {
  indexOp,
  updateOp,
  deleteOp,
  addOp,
  showOp,
  uploadImg,
  uploadFile,
} from "../../api/index";
import base from "../../api/base";
import { wechatConfig } from "../../utils/wxConfig";
import { getUser, login } from "../../utils/login_toast";
export default {
  inject: ["reload"],
  components: {
    Navbar,
    Tabber,
  },
  props: {},
  data() {
    return {
      url: base.apiURL,
      loginURL: base.loginURL,
      active: "1",
      uid: "",
      info: "",
      pinglunList: "",
      userInfo: {
        id:""
      },
      slideList: "",
      videoList: "",
      newsList:"",
      queryParam:{},
      per_page:"",
      last_page:"",
      page:"",
      productQuery: {
        keyword:""
      },
      columns: [
        { name:"全部",children:[{name:"全部",id:"all"}]}
      ],
      goodsList: [],
      classValue:"",
      treeSelectShow:false,
      currentPage:1,
    };
  },
  computed: {},
  created() {
    var invate_uid = this.$route.query.invate_uid;
    if(invate_uid){
      this.$cookies.set("invate_uid", invate_uid);
    }
    var code = this.getUrlKey("code");
    var state = this.getUrlKey("state");
    this.active = this.$route.query.tab;
    if (!this.$cookies.isKey("Authorization") && code) {
      login(this.getUser);
    }
    if (this.$cookies.isKey("userInfo")) {
      this.userInfo = this.$cookies.get("userInfo");
    }
    this.uid = this.$route.query.uid;
    console.log(this.uid);
    this.getShopDetail();
    this.getPinglun();
    this.getSlide();
    this.getVideo();
    this.getNewsList()
    this.getProductList()
    this.getGoodsType()
  },
  mounted() {},
  watch: {},
  methods: {
    toProductDetail(id){
      this.$router.push({
        path: "/productDetail",
        query: {
          id: id,
        },
      });

    },
    //分类选择
    onConfirm(value) {
      var val = this.$refs.classPicker.getValues();
      console.log(val);
      this.classValue = value[0] + " / " + value[1]
      this.treeSelectShow = false;
      if(val[1].id == "all"){
        this.productQuery.cid = ""
      }else{
        this.productQuery.cid = val[1].id
      }
      this.getProductList()
    },
    onSearch(value){
      console.log(value)
      this.getProductList()
    },
    onInputClear(){
      this.productQuery.keyword = ""
      this.getProductList()
    },
    onclear(){
      this.classValue = ""
    },
    toSendProduct(){
      this.$router.push({

      })
    },
    //获取产品分类
    getGoodsType() {
      var _this = this;
      var data = {
        id: _this.uid,
      };
      indexOp("/goods_type/index", data).then((res) => {
        if (res && res.status == 200) {
          res.data.map((item) => {
            if(item._child && item._child.length > 0){
              var arr = []
              item._child.map(child=>{
                child.text = child.name;
                arr.push(child)
              })
              item.text = item.name;
              item.children = arr
              _this.columns.push(item);
            }
          });
        }
        console.log(res);
      });
    },
    //获取产品列表
    getProductList() {
      var _this = this;
      _this.productQuery.id = _this.uid
      indexOp("/goods/index", _this.productQuery).then((res) => {
        _this.$toast.clear();
        if (res && res.status == 200) {
          _this.goodsList = res.data;
        }
        console.log(res);
      });
    },
    //查看更多
    onMore() {
      var _this = this;
      if (_this.page == _this.last_page) {
        _this.$toast("没有更多数据了");
        return;
      }
      _this.$toast.loading({
        message: "",
        forbidClick: true,
      });
      var page = _this.page + 1;
      _this.queryParam.page = page;
      indexOp("/news/index", _this.queryParam).then((res) => {
        _this.$toast.clear();
        if (res && res.status == 200) {
          _this.last_page = res.data.last_page;
          _this.page = res.data.current_page;
          if (res.data.data.length <= 0) {
            _this.$toast("没有更多数据了");
            return;
          }
          for (var i = 0; i < res.data.data.length; i++) {
            _this.newsList.push(res.data.data[i]);
          }
        }
      });
    },
    //获取资讯列表
    getNewsList() {
      var _this = this;
      var data = {
        service_id: this.uid,
      };
      _this.queryParam.service_id = _this.uid;
      indexOp("/news/index", data).then((res) => {
        if (res && res.status == 200) {
          _this.newsList = res.data.data;
          _this.last_page = res.data.last_page;
          _this.page = res.data.current_page;
          _this.per_page = res.data.per_page
        }
        console.log(res);
      });
    },
    //去资讯详情
    toNewsDetail(id) {
      var _this = this;
      this.$router.push({
        path: "/newDetail",
        query: {
          id: id,
        },
      });
    },
    toSendNews(){
      this.$router.push({
        path:"/newAdd",
      })
    },
    onVideoDelete(id) {
      var _this = this;
      var api = "/video/destroy/" + id;

      _this.$dialog
        .confirm({
          title: "提示",
          message: "确认删除这条视频吗？",
          confirmButtonText: "确认",
          cancelButtonText: "取消",
        })
        .then(() => {
          // on close
          indexOp(api).then(res=>{
            if(res && res.status == 200){
              _this.$toast.success("删除成功！")
              setTimeout(()=>{
                _this.reload()
              },800)
            }
            console.log(res)
          })
        })
        .catch(() => {
          // on cancel
        });
    },
    onTabChange(name) {
      console.log(name);
      this.active = name;
      this.setShare();
    },
    //分享
    setShare() {
      const shareInfo = {
        title: `冷鲜柜网-` + this.info.name,
        desc: "聚制冷精英，集行业资源，方便您我他！",
        link:
          base.shareURL +
          "/shifuShopDetail?uid=" +
          this.info.uid +
          "&tab=" +
          this.active + 
          "&invate_uid=" + 
          this.userInfo.id,
        img: "http://api.zglxgw.com/uploads/images/20201128/5fc1e41dbfbaf.jpg",
      };
      wechatConfig(shareInfo);
    },
    //获取店铺详情
    getShopDetail() {
      var _this = this;
      _this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      var data = {
        uid: _this.uid,
      };
      indexOp("/service_user/show", data).then((res) => {
        _this.$toast.clear();
        if (res && res.status == 200) {
          _this.info = res.data;
          _this.setShare();
        }
        console.log(res);
      });
    },
    //获取评论列表
    getPinglun() {
      var _this = this;
      _this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      var data = {
        uid: _this.uid,
      };
      indexOp("/order_comment/index", data).then((res) => {
        _this.$toast.clear();
        if (res && res.status == 200) {
          _this.pinglunList = res.data.data;
        }
      });
    },
    getVideo() {
      var _this = this;
      var data = {
        uid: _this.uid,
      };
      indexOp("/video/index", data).then((res) => {
        _this.$toast.clear();
        if (res && res.status == 200) {
          _this.videoList = res.data.data;
          // _this.getVideoposter();
        }
      });
    },
    //去对话
    toChat() {
      var _this = this;
      if (!_this.$cookies.isKey("userInfo")) {
        _this.$dialog
          .confirm({
            title: "提示",
            message: "您还未登录，请先去登陆。",
            confirmButtonText: "登陆",
            cancelButtonText: "取消",
          })
          .then(() => {
            window.location.href = _this.loginURL;
            // on close
          })
          .catch(() => {
            // on cancel
          });
        return;
      }
      var to_uid = _this.info.uid; //聊天对象 uid
      var form_uid = _this.$cookies.get("userInfo").id; //自己的 uid
      var data = {
        params: {
          to_uid: to_uid,
          from_uid: form_uid,
          chat_type: "normal",
        },
      };
      addOp("/im/build_chat", data).then((res) => {
        console.log(res);
        //跳转
        _this.$router.push({
          path: "/chat",
          query: {
            chat_id: res.data.chat_id,
            to_uid: to_uid,
          },
        });
      });
    },
    //获取轮播
    getSlide() {
      var _this = this;
      indexOp("/slide/index?cid=3").then((res) => {
        if (res && res.status == 200) {
          _this.slideList = res.data;
        }
      });
    },
    //获取登录返回的用户数据
    getUser(userInfo) {
      var _this = this;
      console.log(userInfo);
      _this.userInfo = userInfo;
    },
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    goBack() {
      this.$router.go(-1);
    },
    toEditShop() {
      this.$router.push("/editShifuinfo");
    },
    toUploadVideo() {
      this.$router.push({
        path: "/upload",
      });
    },
    getVideoposter() {
      var _this = this;
      this.videoList.forEach((item) => {
        let video = document.createElement("video");
        let canvas = document.createElement("canvas");
        // video.setAttribute("crossOrigin", "anonymous"); //处理跨域
        video.setAttribute("src", _this.url + item.video_url);
        video.setAttribute("width", 350);
        video.setAttribute("height", 190);
        video.setAttribute("controls", "controls");
        video.setAttribute("autoplay", "autoplay");
        // video.currentTime = 1;
        video.addEventListener("canplay", function () {
          setTimeout(() => {
            canvas.width = video.width;
            canvas.height = video.height;
            canvas
              .getContext("2d")
              .drawImage(video, 0, 0, video.width, video.height); //绘制canvas
            var dataURL = canvas.toDataURL("image/png"); //转换为base64
            item.cover = dataURL;
            //     console.log(dataURL);
          }, 200);
        });
      });
    },
  },
};
</script>

<style scoped lang="less">
  @ThemColor: #2F78DC;
    .btns {
      position: fixed;
      right: 15px;
      bottom: 80px;

      .btn {
        height: 35px;
        width: 120px;
        border-radius: 35px;
        font-size: 14px;
        margin: 10px auto 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: @ThemColor;
        box-shadow: 4px 6px 28px -10px rgba(79, 77, 77, 0.50);
        box-sizing: border-box;
        color: #fff;

        span {
          line-height: 1;
        }

        i {
          margin-right: 10px;
          color: #fff;
        }
      }
    }

  .product-list{
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
  }
  .shop-detail .tabs-box .card-box .product-list .item{
    width: 33%;
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: none;
  }
  .product-list .item img{
    width: 100%;
    height: 65px;
    object-fit: cover;
    margin-bottom: 5px;
  }
  .product-list .item span{
    font-size: 14px;
  }
    .search-box {
      padding: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .input-box {
        width: 70%;
        position: relative;
        // background: #f2f2f2;

        .icon {
          position: absolute;
          left: 10px;
          top: 50%;
          transform: translateY(-50%);
          z-index: 10;
        }

        .van-cell {
          padding: 0;
          border-radius: 35px;
          line-height: 35px;
          font-size: 14px;
        }

        .input {
          width: 100%;
          background: #f2f2f2;
          border-radius: 35px;
          height: 35px;
          border: none;
          font-size: 14px;
          padding-left: 35px;

          .van-search__content {
            background: #f2f2f2;
            padding-left: 0;
          }
        }
      }

      .type-btn {
        width: 27%;
        height: 35px;
        border-radius: 35px;
        background: #fff;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          margin-right: 5px;
        }
      }
    }
    .type {
      padding: 5px 15px;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
</style>